import * as React from 'react';
import { FC, useEffect, ReactNode } from 'react';
import type { Game } from 'app/CasinoGames/types';
import type { CampaignView } from 'app/CasinoGames/useJackpotAggregatorCampaignViews';
import Sidebar from './Sidebar';
import useFullscreen from './useFullscreen';
import useGameSize from './useGameSize';

const hideScrollbars = () => {
  document.documentElement.style.overflow = 'hidden'; // firefox, chrome
  (document.body as unknown as { scroll: string }).scroll = 'no'; // ie only
};

const showScrollbars = () => {
  document.documentElement.style.overflow = 'auto'; // firefox, chrome
  (document.body as unknown as { scroll: string }).scroll = 'yes'; // ie only
};

const CasinoGameModal: FC<{
  game: Game;
  onClose: () => void;
  children: ReactNode;
  jackpotAggregatorCampaignViews: CampaignView[];
}> = ({ game, onClose, children, jackpotAggregatorCampaignViews }) => {
  const fullscreen = useFullscreen();
  const gameSize = useGameSize(window, game.windowSize, fullscreen);

  useEffect(() => {
    const onCloseGameModal = (e: MessageEvent) => {
      if (e.data === 'closeGameModal') onClose();
    };

    hideScrollbars();
    window.addEventListener('message', onCloseGameModal);

    return () => {
      showScrollbars();
      window.removeEventListener('message', onCloseGameModal);
    };
  }, []);

  return (
    <div id="casino-game-modal">
      <div id="casino-game-ui" style={gameSize.uiSize}>
        <Sidebar
          game={game}
          fullscreen={fullscreen}
          onClose={onClose}
          jackpotAggregatorCampaignViews={jackpotAggregatorCampaignViews}
        />
        <div id="game-content-area" className="game-content-area" style={gameSize.contentSize}>
          {children}
        </div>
      </div>
    </div>
  );
};

export default CasinoGameModal;
